import { useQuery } from 'react-query';

import { getCardImportance as queryFn } from 'api/endPoints/getCardImportance';
import { IVersion } from 'api/queries/getProjectVersionsList.query';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetCardImportance = (params: QueryParams) => {
    return useQuery<ImportantResponse[], QueryError, ImportantResponse[], [QueryKeys, unknown]>({
        queryKey: ['getCardImportance', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.metaDataId),
    });
};

export interface QueryParams {
    metaDataId?: IVersion['id'];
}

export interface ImportantResponse {
    id: number;
    name: string;
    label: string;
}
